import React from 'react';
import SectionContainer from '../layout/SectionContainer';

export default function DataTableShell({
  title,
  subtitle,
  action = null,
  footer = null,
  className = '',
  contentClassName = '',
  children,
}) {
  return (
    <SectionContainer className={className}>
      <div className="mb-3 flex items-center justify-between gap-3">
        <div>
          {title ? <p className="cc-text-primary text-sm font-semibold">{title}</p> : null}
          {subtitle ? <p className="cc-text-muted text-xs">{subtitle}</p> : null}
        </div>
        {action}
      </div>
      <div className={contentClassName}>{children}</div>
      {footer ? <div className="mt-3">{footer}</div> : null}
    </SectionContainer>
  );
}
